module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBold.54636a7.woff";